var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ui-progress-bar',{attrs:{"percentage":_vm.BarWidth}}),_c('div',{staticClass:"pt-2 text-xs text-gray-700 font-family-inherit"},[_vm._v(" "+_vm._s(_vm.used)+" von "+_vm._s(_vm.total)+" Einheiten verbraucht ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }